var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 734 517",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M291.667 367.371v-218.07l191.667 109.037L291.667 367.37zM718.009 80.68c-8.433-31.754-33.283-56.766-64.833-65.254C595.988 0 366.667 0 366.667 0S137.346 0 80.154 15.425c-31.55 8.488-56.4 33.5-64.833 65.254C0 138.242 0 258.334 0 258.334s0 120.095 15.32 177.654c8.434 31.758 33.284 56.767 64.834 65.258 57.192 15.421 286.513 15.421 286.513 15.421s229.321 0 286.509-15.42c31.55-8.492 56.4-33.5 64.833-65.26 15.325-57.558 15.325-177.653 15.325-177.653s0-120.092-15.325-177.655z"
  })));
}
export default SvgYoutubeLogo;